import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_CONTRACT_FOR_PROVIDER } from "src/api-setup/api-endpoints";
import { API_CONSTANTS } from "../../providerPayRequestDashboard/utils/constants";

/*
 * Contract detail for the selected contract. Every element of row_result is one
 * tier; element 0 doubles as the contract header (rate_type, period_type,
 * is_transactional, caps) that decides which pricing model applies.
 */
export const getContractForProvider = async (
  cookiesData,
  dispatch,
  { providerId, locationMstrKey, contractMstrKey }
) => {
  if (!cookiesData || !providerId || !contractMstrKey) return [];

  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_provider_id: providerId,
      in_location_mstr_key: locationMstrKey || 0,
      in_contract_mstr_key: contractMstrKey,
      in_sort_number: API_CONSTANTS.DEFAULT_SORT_NUMBER,
      in_sort_order: API_CONSTANTS.DEFAULT_SORT_ORDER_ASC,
    };

    const response = await POSTAPI(false, GET_CONTRACT_FOR_PROVIDER, null, apiHeaders, requestBody, dispatch);
    const rowResult = response?.data?.row_result;

    return Array.isArray(rowResult) ? rowResult : [];
  } catch (error) {
    console.error("Error fetching contract for provider:", error);
    return [];
  }
};
